import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter7() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">The Impact of Autonomy</p>
        <p className="chapter__paragraph">
          Over the course of a few months, Bluewhite was able to measure radio and network
          performance across several different use cases. Ultimately, the team noticed some clear
          benefits: the new solution not only facilitated real-time communications for safety
          mechanisms in robotic equipment, but also allowed for larger-volume data transmission and
          the analysis of real-time data generated by the automation kit’s many sensors.
        </p>
        <p className="chapter__paragraph">
          As Chan describes it, the edge unlocks the full potential of automation technology:
          “That’s when a tractor becomes a data collection engine,” she says, “harvesting data that
          can get digested, analyzed, synthesized, and fed back to the farms to drive innovation.”
        </p>
        <p className="chapter__paragraph">
          That’s something that can translate from a vineyard to a citrus grove to an almond farm.
          “The private network provides a customization capability that enterprises need,” Chan
          says. “Today, it just happens to be tractors. People do not realize the power of 5G…the
          bandwidth you get with this technology is very impressive.”
        </p>
        <p className="chapter__paragraph">
          But nobody has a deeper understanding or appreciation of this power than the vineyard
          operators who have participated in the pilot program. The same data collection that helped
          Bluewhite run their automated solution also allowed growers to collect and share data on
          vital factors like air pollution, soil pollution, and water-quality control with various
          government agencies - while also improving their ability to communicate with team members
          across the farm.
        </p>
      </section>

      <section>
        <PullQuote
          quote={
            '“[This autonomous farm] will improve productivity, safety, and bring more food to the table. It will also bring the glory back to agriculture.”'
          }
          author={'Alon Ascher,'}
          source={'Bluewhite'}
        />
      </section>
      <section className="chapter" style={{ marginBottom: '1.5rem' }}>
        <p className="chapter__paragraph">
          Alon Ascher projects that this autonomous farm “will improve productivity, safety, and
          bring more food to the table. It will also positively affect the community while bringing
          the glory back to agriculture. After years of workers leaving farming for easier or more
          technological jobs in the city, we see the young generation coming back to the farm, now
          as robotic farmers, with pride and joy.”
        </p>
      </section>
    </>
  );
}

export default Chapter7;
